import { createClient as initializeContenfulClient } from 'contentful';

interface App {
  name: string;
  link: string;
  image: string;
  isActive?: boolean;
}

const apps: App[] = [];

const client = initializeContenfulClient({
  space: process.env['REACT_APP_CONTENTFUL_SPACE_ID'] || '8cqca1fqnslf',
  accessToken: process.env['REACT_APP_CONTENTFUL_TOKEN'] || 's5MLe8zBcFm-DGTBsUilOzrXR_OMLXaAY7x73ENGFD0',
  environment: process.env['REACT_APP_ENVIRONMENT'] || 'QA'
});

// Helpers for cookie handling in browser
const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') return null;
  const m = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/([.$?*|{}()\[\]\\\/\+^])/g, '\\$1') + '=([^;]*)'));
  const captured = m && typeof m[1] === 'string' ? m[1] : undefined;
  return captured ? decodeURIComponent(captured) : null;
};

const getRootDomain = (): string | null => {
  if (typeof window === 'undefined') return null;
  try {
    const host = window.location.hostname;
    if (host === 'localhost' || /^\d+\.\d+\.\d+\.\d+$/.test(host)) return null;
    const parts = host.split('.').filter(Boolean);
    if (parts.length <= 1) return null;
    return `.${parts.slice(-2).join('.')}`;
  } catch {
    return null;
  }
};

const encodeCookieValue = (name: string, value: string): string => {
  return name === 'email' ? value : encodeURIComponent(value);
};

const setCookie = (name: string, value: string, maxAgeSeconds = 43200) => {
  if (typeof document === 'undefined') return;
  const domain = getRootDomain();
  const attrs = [
    `${name}=${encodeCookieValue(name, value)}`,
    'Path=/',
    `Max-Age=${maxAgeSeconds}`,
    'SameSite=None',
    'Secure'
  ];
  if (domain) attrs.push(`Domain=${domain}`);
  document.cookie = attrs.join('; ');
};

export const normalizeEmailDomainIfNeeded = (): string | null => {
  if (typeof window === 'undefined') return null;
  try {
    const allowed = ['edible.store', 'edible.com', 'netsolace.com'];
    let email = getCookie('email') || (typeof localStorage !== 'undefined' ? localStorage.getItem('email') : null) || (typeof sessionStorage !== 'undefined' ? sessionStorage.getItem('email') : null);
    if (email && (email?.split('@')[1] === 'dofruit.com' || email?.split('@')[1] === 'dofruit.ca')) return `${email.split('@')[0]}@edible.store`;
    if (!email || !email.includes('@')) email = `${getCookie('userName') || ''}@edible.store`;
    const parts = email.split('@');
    // if (parts.length !== 2) return;
    // const local = parts[0];
    const domainRaw = parts[1];
    if (!domainRaw) return null;
    const domainLc = domainRaw.toLowerCase();
    if (!allowed.includes(domainLc)) {
      const updated = `${getCookie('userName') || ''}@edible.store`;
      setCookie('email', updated, 43200);
      try { if (typeof localStorage !== 'undefined') localStorage.setItem('email', updated); } catch {}
      try { if (typeof sessionStorage !== 'undefined') sessionStorage.setItem('email', updated); } catch {}
    }
    return email;
  } catch {
    return null;
  }
};

export const fetchApps = async (): Promise<App[] | undefined> => {
  try {
    const response = await client.getEntries({
      content_type: process.env['CONTENT_TYPE'] ||  'myEdibleLanding'
    });

    const widgetName = process.env['WIDGET_NAME'] || 'myEdibleWidgets';

    const widgetsGroup = response.items?.[0]?.fields?.[widgetName] || {};
    const widgets = Array.isArray((widgetsGroup as any)) ? (widgetsGroup as any) : [];

    let appsResponse = widgets
      .map((item: any) => {
        const rawLink: string | undefined = item.fields?.link;
        const normalized = (rawLink || '').toLowerCase();
        let link = rawLink || '';
        if (normalized.includes('ediblebrands.zendesk.com')) {
          normalizeEmailDomainIfNeeded();
          link = `https://func-prd-ns-eu2-node-zendesk-001.azurewebsites.net/api/myTickets?email=${encodeURIComponent(getCookie('email') || '')}`;
        }

        return {
          name: item.fields?.name,
          link,
          image: item.fields?.image && item.fields.image[0]?.url,
          isActive: item.fields?.isActive !== undefined ? item.fields.isActive : true
        } as App;
      });

    return appsResponse;
  } catch (error) {
    console.error('Error fetching apps:', error);
    return apps;
  }
};
